import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { plcEventList } from "../../../pages/main-pages/plc/events/list/EventList";

interface eventSliceReducer {
  eventDetails: plcEventList[];
}
let initialState: eventSliceReducer = {
  eventDetails: [],
};

const EventSliceReducer = createSlice({
  name: "plcEvents",
  initialState,
  reducers: {
    setPlcEventDetails(state, action: PayloadAction<plcEventList[]>) {
      state.eventDetails = action.payload;
    },
  },
});

export const { setPlcEventDetails } = EventSliceReducer.actions;

export default EventSliceReducer.reducer;
